import * as React from "react";
import { SVGProps } from "react";
export const ReturnIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M6.875 14.375L3.125 10.625C3.04167 10.5277 2.97567 10.427 2.927 10.323C2.87834 10.219 2.854 10.1113 2.854 10C2.854 9.88867 2.87834 9.77767 2.927 9.667C2.97567 9.55567 3.04167 9.45834 3.125 9.375L6.875 5.625C7.05567 5.44434 7.264 5.354 7.5 5.354C7.736 5.354 7.94434 5.44434 8.125 5.625C8.30567 5.80567 8.396 6.014 8.396 6.25C8.396 6.486 8.30567 6.69434 8.125 6.875L5.875 9.125H15.75V6.708C15.75 6.472 15.8367 6.26734 16.01 6.094C16.184 5.92 16.389 5.833 16.625 5.833C16.861 5.833 17.066 5.92 17.24 6.094C17.4133 6.26734 17.5 6.472 17.5 6.708V10C17.5 10.236 17.4133 10.441 17.24 10.615C17.066 10.7883 16.861 10.875 16.625 10.875H5.875L8.125 13.125C8.30567 13.3057 8.396 13.514 8.396 13.75C8.396 13.986 8.30567 14.1943 8.125 14.375C7.94434 14.5557 7.736 14.646 7.5 14.646C7.264 14.646 7.05567 14.5557 6.875 14.375Z"
            fill="currentColor"
        />
    </svg>
);
ReturnIcon.displayName = "ReturnIcon";
